module.exports = __webpack_public_path__ + "static/img/thumbs-up.58b0acf1.svg";